export const DIRECTIONS = [
  {
    key: 0,
    text: 'Incoming/Outgoing',
    value: 'incoming/outgoing',
  },
  {
    key: 1,
    text: 'Incoming',
    value: 'incoming',
  },
  {
    key: 2,
    text: 'Outgoing',
    value: 'outgoing',
  },
];

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

export default {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATETIME_FORMAT,
  DEFAULT_TIMEZONE,
};

export const SEND_OPTIONS = {
  Immediate: 1,
  Scheduled: 2,
  Recurring: 3,
};
